module.exports = __webpack_public_path__ + "img/location.f4dc189c.svg";